module.exports = __webpack_public_path__ + "img/05_speaker4.c7e9f5cd.png";